import React, { useEffect, useState } from "react";
import {
  createNewsServer,
  newsServer,
  updateNewsServer,
  uploadImageServer,
} from "../../../apis/news";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { newsSchema } from "../../../lib/validations/uservalidation";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorHTML from "../../../lib/common/EditorHTML";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function Addnews() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [prevDesc, setPrevDesc] = useState(false);
  const [addNewsInitial, setAddNewsInitial] = useState({
    title: "",
    description: "",
    image: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // false = Paragraph
      ["blockquote", "code-block"],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      // [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  useEffect(() => {
    if (id) {
      editNews(id);
    }
  }, [id]);

  const editNews = async (id) => {
    setEditLoader(true);
    try {
      const res = await newsServer({ id });
      if (res.result) {
        setAddNewsInitial({
          title: res.result.title,
          description: res.result.description,
          image: res.result.image,
        });
        setPrevDesc(res.result.description);
        setEditLoader(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const path = await uploadImageServer(formData);
    console.log({ fileName: path.path });
    if (path) {
      formik.setFieldValue("image", path.path);
    }
  };

  const formik = useFormik({
    initialValues: addNewsInitial,
    enableReinitialize: true,
    validationSchema: newsSchema,
    onSubmit: async (values) => {
      try {
        // Clean HTML tags from description
        // const cleanDescription = new DOMParser()
        //   .parseFromString(values.description, "text/html")
        //   .body.textContent.trim();
        setLoading(true);
        console.log(values);
        let res;
        if (id) {
          values.id = id;
          res = await updateNewsServer(id, values);
          console.log(res);
        } else {
          res = await createNewsServer(values);
        }
        setLoading(false);
        formik.resetForm();
        navigate("/news");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/news");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <TextInputFormik
                    label="Title"
                    field="title"
                    formik={formik}
                  />

                  <div className="mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={formik.values.description || ""}
                      onChange={(content) =>
                        formik.setFieldValue("description", content)
                      }
                      onBlur={() => formik.setFieldTouched("description", true)}
                      modules={modules}
                      style={{ height: 400 }}
                    />

                    {/*<EditorHTML
                      content={prevDesc}
                      field="description"
                      setContent={formik.setFieldValue}
                      onFocus={formik.handleBlur}
                      style="border:solid 1px red;"
                    />*/}
                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="text-danger">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                  <div className="input-block">
                    <input
                      className="form-control"
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={uploadFile}
                      onBlur={formik.handleBlur}
                      placeholder="Upload File"
                      style={{ width: "250px" }}
                    />
                    {formik.errors.image && formik.touched.image && (
                      <span className="text-danger">{formik.errors.image}</span>
                    )}
                    {formik.values.image && (
                      <img src={formik.values.image} width={300} />
                    )}
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
